import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations directly
import en from './locales/en.json';
import es from './locales/es.json';
import ar from './locales/ar.json';

// Get the language from localStorage, default to 'en' if not found
const savedLanguage = localStorage.getItem('language') || 'en';

// Configure i18next without language detection
i18n
  .use(initReactI18next) // Pass i18n down to react-i18next
  .init({
    fallbackLng: 'en', // Fallback language if no language is set
    lng: savedLanguage, // Set the language from localStorage
    debug: true,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    resources: {
      en: {
        translation: en, // Directly imported en.json
      },
      es: {
        translation: es, // Directly imported es.json
      },
      ar: {
        translation: ar, // Directly imported ar.json
      },
    },
  });

export default i18n;
